import React from 'react';
import Link from 'gatsby-link';

import GridContainer from '../grid-container';
import GridRow from '../grid-row';
import GridCol from '../grid-col';

export default ({ children, rowOnly }) => (
  <GridContainer>
    {rowOnly ? (
      <GridRow>{children}</GridRow>
    ) : (
      <GridRow>
        <GridCol>{children}</GridCol>
      </GridRow>
    )}
  </GridContainer>
);



// WEBPACK FOOTER //
// ./src/components/grid-wrap/index.js